import {type IAsset} from '@netx/core-asset-next/schema';
import {type IConstituentClip} from '../schema';

export const canManageConstituentClips = (
	asset?: IAsset,
	constituentClip?: IConstituentClip,
): constituentClip is IConstituentClip => {
	return !!asset && !!constituentClip;
};
